var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-mode-switch"},[_c('v-btn-toggle',{attrs:{"value":_vm.value,"mandatory":""},on:{"change":_vm.handleChange}},[_c('v-btn',{attrs:{"value":"grid"}},[_c('v-icon',[_vm._v("mdi-view-grid-outline")])],1),_c('v-btn',{attrs:{"value":"list"}},[_c('v-icon',[_vm._v("mdi-reorder-horizontal")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }